import { Box, Typography } from '@mui/material';
import { clearCache } from 'clear-cache';
import InteractiveAlertDialog from 'components/Dialoges/InteractiveAlertDialog';

const VersionMismatchPopup = (props: { open: boolean }) => (
  <InteractiveAlertDialog
    open={props.open}
    title='App Update Available'
    content={
      <Box p={3}>
        <Typography>Please Reload to get the latest version.</Typography>
      </Box>
    }
    actions={[
      {
        label: 'Reload',
        handler: () => clearCache(true),
      },
    ]}
  />
);

export default VersionMismatchPopup;
